import { NavLink } from "react-router-dom"
import allfcLightLogo from "@/assets/logos/allfc-light.svg"
import Icon from "@/components/common/Icon"

const MENU_ITEMS = [
  { to: "/admin", label: "Dashboard", icon: "dashboard", end: true },
  { to: "/admin/tournaments", label: "대회관리", icon: "trophy", end: false },
  { to: "/admin/entries", label: "참가신청", icon: "clipboard", end: false },
  { to: "/admin/brackets", label: "대진관리", icon: "bracket", end: false },
]

interface AdminSidebarProps {
  isOpen: boolean
  onClose: () => void
}

function menuLinkClass({ isActive }: { isActive: boolean }): string {
  return `focus-ring app-txt-body2 flex items-center gap-3 px-3 py-2.5 font-bold transition ${
    isActive
      ? "bg-app-primary-500 text-app-text-100"
      : "text-app-secondary-700 hover:bg-app-secondary-800 hover:text-app-text-100"
  }`
}

export default function AdminSidebar({
  isOpen,
  onClose,
}: Readonly<AdminSidebarProps>) {
  function onClickDim() {
    onClose()
  }

  function onClickMenuItem() {
    onClose()
  }

  return (
    <>
      {isOpen && (
        <button
          type="button"
          onClick={onClickDim}
          aria-label="사이드바 닫기"
          className="fixed inset-0 z-30 bg-[var(--app-color-dim)] lg:hidden"
        />
      )}

      <aside
        className={`fixed inset-y-0 left-0 z-40 flex w-72 flex-col bg-app-secondary-900 transition-transform duration-300 lg:translate-x-0 ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex h-20 items-center gap-3 border-b border-white/10 px-6">
          <img
            src={allfcLightLogo}
            alt="ALLFC"
            className="h-9 w-auto"
          />
          <span className="app-txt-caption border-l border-white/20 pl-3 text-app-secondary-700">
            ADMIN
          </span>
        </div>

        <nav
          aria-label="관리자 메뉴"
          className="flex-1 overflow-y-auto px-4 py-6"
        >
          <ul className="flex list-none flex-col gap-1">
            {MENU_ITEMS.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  end={item.end}
                  onClick={onClickMenuItem}
                  className={menuLinkClass}
                >
                  <Icon
                    name={item.icon}
                    size={19}
                  />
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="m-4 border-l-2 border-app-primary-500 bg-app-secondary-800 p-4">
          <p className="app-txt-caption text-app-text-100">운영 문의</p>
          <p className="app-txt-caption mt-1 font-medium text-app-secondary-700">
            대회 운영 중 도움이 필요하면 협회 담당자에게 문의하세요.
          </p>
        </div>
      </aside>
    </>
  )
}
